<template>
	<section>
		<alert :type="alert.type" :mensagem="alert.msg" />
	    <filtros :filter_data="filter_data" @filtrar="filtrar" />

	    <table class="table table-striped table-sm">
    		<thead align="center">
    			<th>ID</th>
    			<th>DATA</th>
    			<th>HORA</th>
    			<th>AUTOR</th>
    			<th></th>
    		</thead>
			
			<transition mode="out-in" name="leftIn">
	    		<tbody v-if="relatorios" align="center">
	    			<tr v-for="(rel, index) in relatorios.result.data" :key="index">
						<td>{{ rel.id }}</td>
						<td>{{ rel.created_at | moment("DD/MM/YYYY") }}</td>
						<td>{{ convert_hor(rel.created_at) | moment("HH:mm:ss") }}</td>
						<td>{{ get_user_name(rel.autor) }}</td>
						<td>
							<font-awesome-icon icon="eye"      class="info pointer icon" @click="view(rel)" />
							&nbsp;
							<font-awesome-icon icon="file-pdf" class="info pointer icon" @click="get_pdf(rel.id)" />
						</td>
					</tr>
	    		</tbody>
	    		<Loading v-else />
	    	</transition>
    	</table>

    	<controls :data="constrol_data" @refresh="navigate" @alert="show_alert" />
    	<newRel @alert="show_alert" :relatorio="modal_data" @create_pdf="get_pdf" />
	</section>
</template>

<script>
	import api      from "@/mixins/api.js"
	import pdf      from "@/mixins/pdf.js"
	import replace  from "@/mixins/replace.js"
	import alert 	from "@/components/Tools/alert.vue"
	import filtros  from "@/components/Tools/filter.vue"
	import controls from "@/components/Tools/Table_Control.vue"
	import newRel   from "@/components/Modal/Relatorio.vue"

	export default {
		name: 'ISD',
		props: ["table", "method"],
		mixins: [api, pdf],
		components: { controls, newRel, filtros, alert },

		data() { 
			return {
				alert: { type: "", msg: "" },
				relatorios: null,
				constrol_data: {},
				modal_data: {},
				action: "",
				unidades: {},
				users: {},

				direction: { order: "DESC", by: "ID" },

				pagination: "10?",
				string_filter: "",

				filter_data: [
					{ 
						name: "id",         
						label: "id",      
						operador: "igual", 
						type: "text",   
						data_get: ""
					},
					{ 
						name: "created_at", 
						label: "data",    
						operador: "like",  
						type: "date",   
						data_get: ""
					},
					{ 
						name: "autor",      
						label: "autor",   
						operador: "igual", 
						type: "select", 
						data_get: "User"
					},
				]
			}
		},

		created() {
			this.$emit('update:rel_name', 'de informação sobre ');
			this.$emit('update:pdf', false);
			this.$emit('update:button', { display: true, class: 'btn-success', label: 'Novo'});
			this.get_users();
			//this.get_unidades()
			this.get_data();
		},

		computed: {
			ordenation() {
				return `order=${this.direction.order}&by=${this.direction.by}`;
			},

			order_icon() {
				return ( this.direction.order == "asc" ) ? "arrow-up" : "arrow-down";
			}
		},

		methods: {
			get_pdf(payload) {
				this.pdf_get_relatorio(payload);
			},

			async get_data() {
				this.relatorios = null;
				this.relatorios = await this.GET("Relatorio", `Paginate/${this.pagination}${this.ordenation}${this.string_filter}`);

				this.constrol_data = {
					current_page: this.relatorios.result.current_page,
					last_page:    this.relatorios.result.last_page,
					per_page:     this.relatorios.result.per_page,
					total:        this.relatorios.result.total,
				}
			},

			async get_users() {
				this.users = await this.GET("User");
			},

			async get_unidades() {
				this.unidades = await this.GET("Unidade");
			},

			get_user_name(payload) {
				for (var i = 0; i <= this.users.result.length -1; i++) {
					if ( this.users.result[i].id == payload){
						return this.users.result[i].name;
					}
				}
			},

			get_unidade_name(payload) {
				for (var i = 0; i <= this.unidades.result.length -1; i++) {
					if ( this.unidades.result[i].id == payload){
						return this.unidades.result[i].nome;
					}
				}
			},

			orderBy(payload) {
				if ( payload == this.direction.by ) {
					this.direction.order = ( this.direction.order == 'desc' ) ? 'asc' : 'desc';
				}else{ 
					this.direction.by = payload;
				}

				this.get_data();
			},

			filtrar(payload) {
				this.string_filter = payload;
				this.get_data();
			},	

			navigate(payload) {
				this.get_data(payload);
			},

			navigate(payload) {
				this.pagination = payload;
				this.get_data();
			},

			btn_click() { 
				this.modal_data = { corpo: "", titulo: "" };
				this.action = "add";
				$("#modal-relatorio").modal();
			},

			convert_hor(payload){
				var nova_hora = new Date(payload);
				nova_hora.setHours(nova_hora.getHours()-3);
				return nova_hora;
			},

			view(payload) { 
				this.modal_data = payload;
				this.action = "view";
				$("#modal-relatorio").modal();
			},

			show_alert(payload) {
				this.alert.type = (payload.status == "success") ? "alert-success" : "alert-danger";
				this.alert.msg  = payload.result;

				$("#modal-relatorio").modal('hide');
				this.get_data();

				$("#app-alert").show();
				setTimeout(() => $("#app-alert").hide(), 3000 );
			}
		}
	};
</script>

<style>
</style>